import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

export default class extends Controller {
  static targets = ["input"]
  static values = { scale: Number }

  declare inputTarget: HTMLInputElement
  declare mask: any
  declare hasScaleValue: boolean
  declare scaleValue: number

  connect() {
    // Default to 2 decimal places if not specified
    const scale = this.hasScaleValue ? this.scaleValue : 2

    this.mask = IMask(this.inputTarget, {
      mask: Number,
      scale: scale,  // configurable decimal places
      thousandsSeparator: '.',
      padFractionalZeros: false,
      normalizeZeros: true,
      radix: ',',  // use comma as decimal separator
      mapToRadix: ['.'],  // also accept dot and convert to comma
      autofix: true,
    })

    // Listen for form submission
    const form = this.inputTarget.closest('form')
    if (form) {
      form.addEventListener('submit', this.handleSubmit)
    }
  }

  handleSubmit = (event: Event) => {
    // Get the unmasked value (pure number)
    const unmaskedValue = this.mask.unmaskedValue
    
    // Convert to proper decimal format for submission
    // Replace comma with dot for numeric value
    const numericValue = unmaskedValue.replace(',', '.')
    
    // Temporarily set the input value to the numeric value for submission
    this.inputTarget.value = numericValue
  }

  disconnect() {
    const form = this.inputTarget.closest('form')
    if (form) {
      form.removeEventListener('submit', this.handleSubmit)
    }
    this.mask?.destroy()
  }
}
